module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0005-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("In memory of the late Dr. Robert C. Atkins, 1930–2003."), _c('br'), _vm._v("Because of his fearless tenacity, millions of us live better lives today.")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("“If I can see far, it is because I have stood on the shoulders of giants.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Sir Isaac Newton "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478d7a13","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04.vue
// module id = 60
// module chunks = 0